import { render, staticRenderFns } from "./ModelCenter.vue?vue&type=template&id=5d9949d4&scoped=true&"
var script = {}
import style0 from "./ModelCenter.vue?vue&type=style&index=0&id=5d9949d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9949d4",
  null
  
)

export default component.exports